<template>
    <div class="editor-menu-bar">

        <div v-for="(item, index) in listMenu" :key="index" class="editor-menu-bar-item"
            :class="selectedItemId == item.id ? 'btn-active' : ''" @click="changeMenu(item.id)">
            <!-- 按钮类型0 -->
            <div v-if="item.type == 0" class="editor-menu-bar-btn0">
                <span class="editor-menu-bar-btn0-icon" :class="item.css"></span>
                <span class="editor-menu-bar-btn0-title">{{ item.cnName }}</span>
            </div>
        </div>
    </div>
</template>

<script>

import { selectMenuByLevel } from '@/api/Common';
import { useRouter, useRoute } from 'vue-router';



export default {
    name: 'EditorMenuBar',
    data() {
        return {
            selectedItemId: 0,
            listMenu: [
                { "id": 7, "pid": 0, "cnName": "图层管理", "enName": "Layer Management", "url": "/map/editor", "perams": null, "type": 0, "css": "icon-icomoon-layer-management", "icon": null, "level": 1, "orderNum": 1, "isShow": 1, "bak": null },
                // { "id": 8, "pid": 0, "cnName": "协作人员", "enName": "Collaborator", "url": "/map/cooperation", "perams": null, "type": 0, "css": "icon-icomoon-task-cooperation", "icon": null, "level": 1, "orderNum": 2, "isShow": 1, "bak": null },
                // { "id": 9, "pid": 0, "cnName": "业务动态", "enName": "Business Dynamics", "url": "/map/reply", "perams": null, "type": 0, "css": "icon-icomoon-business-dynamic", "icon": null, "level": 1, "orderNum": 3, "isShow": 1, "bak": null },
                // { "id": 10, "pid": 0, "cnName": "订单分拣", "enName": "Order Pick", "url": "/map/fendan", "perams": null, "type": 0, "css": "icon-icomoon-order-picking1", "icon": null, "level": 1, "orderNum": 4, "isShow": 1, "bak": null }, 
                // { "id": 11, "pid": 0, "cnName": "日志管理", "enName": "Log Management", "url": "/map/log", "perams": null, "type": 0, "css": "icon-icomoon-log-information", "icon": null, "level": 1, "orderNum": 5, "isShow": 1, "bak": null }, 
                // { "id": 12, "pid": 0, "cnName": "分享导出", "enName": "Share Export", "url": "/map/share", "perams": null, "type": 0, "css": "icon-icomoon-share", "icon": null, "level": 1, "orderNum": 6, "isShow": 1, "bak": null }
            ],
            router: null,
            route: null,
            layerList: [],
        }
    },
    props: {
        level: Number
    },
    mounted() {
        this.router = useRouter();
        this.route = useRoute();

        this.changeMenu(7);

    },
    methods: {
        changeMenu(id) {
            let query = this.route.query;
            this.selectedItemId = id;
            for (const item of this.listMenu) {
                if (item.id == id) {
                    if (item.url != null) {
                        if (item.perams == null) {
                            this.$emit('nav-change', { path: item.url });
                            this.router.replace({ path: item.url, query: query });
                        } else {
                            this.$emit('nav-change', { path: item.url });
                            this.router.replace({ path: item.url, query: item.perams });
                        }
                    }
                    break;
                }
            }
        }

    }
}

</script>

<style scoped>
.editor-menu-bar {
    color: #fff;
    top: 20px;
    width: 100%;
    position: relative;
    float: left;
}

.btn-active {
    background-color: #0095ff;
    color: #fff !important;
}

.editor-menu-bar-item {
    color: #b2bcc5;
    padding: 10px 0px;
    cursor: pointer;
}



.editor-menu-bar-btn0 {
    text-align: left;
    margin-left: 14px;
    font-size: 12px;
    height: 20px;
    position: relative;
    white-space: nowrap;
}

.editor-menu-bar-btn0-icon {
    width: 20px;
    background-position: 0 0;
    display: inline-block;
    font-size: 16px;
    color: #fff;
    vertical-align: middle;
    text-align: center;
    line-height: 20px;
}

.editor-menu-bar-btn0-title {

    margin-left: 6px;
    vertical-align: middle;
    white-space: nowrap;
    display: inline-block;
}


.maps-count-bg {
    position: absolute;
    right: 7px;
    height: 14px;
    width: 30px;
    background-color: #304250;
    border-radius: 40px;
    top: 3px;
}

.maps-count {
    width: 30px;
    height: 14px;
    position: absolute;
    right: 7px;
    z-index: 10;
    text-align: center;
    line-height: 20px;
}
</style>